import { useEffect, useState } from "react";
import { HardHat } from "lucide-react";
import { api } from "@/lib/api";
import { useApi } from "@/components/common";
import { useT } from "@/i18n";
import { DailyLogs, Punch } from "@/views/construction/FieldTab";
import { Drawings } from "@/views/construction/SiteTab";
import { CrewCheckin, FuelReceipt } from "@/views/construction/CrewTools";
import { SitePending } from "@/views/construction/CashflowTools";
import { ForecastStrip } from "@/views/construction/ReleaseTools";
import { WeatherBoard } from "@/views/construction/QualityTools";
import { ProjectGallery } from "@/views/construction/SitePhotos";
import { InstallHint } from "./InstallHint";

/** /m/site — foreman / site-engineer phone view: pick project, daily log with weather, punch & inspections. */
export default function MobileSite() {
  const { t } = useT();
  const projects = useApi("/construction/projects");
  const [pid, setPid] = useState("");
  const list = (projects.data || []).filter((p) => !["done", "cancelled", "closed"].includes(p.state));
  const cur = pid || list[0]?.id;
  useEffect(() => {
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
    const platform = /android/i.test(navigator.userAgent) ? "android" : /iphone|ipad|ipod/i.test(navigator.userAgent) ? "ios" : "desktop";
    const ping = (synced = 0) => api.post("/construction/site-app/ping", { standalone, platform, synced }).catch(() => {});
    ping();
    const msg = (e) => { if (e.data?.type === "offline-replayed" && e.data.sent) ping(e.data.sent); };
    navigator.serviceWorker?.addEventListener("message", msg);
    return () => navigator.serviceWorker?.removeEventListener("message", msg);
  }, []);
  if (projects.error) return <div className="p-4 text-sm text-muted-foreground" data-testid="site-unavailable">{t("cst.unavailable")}</div>;
  if (!cur) return null;
  return <div className="p-3 space-y-3 max-w-xl mx-auto" data-testid="mobile-site">
    <div className="flex items-center gap-2 font-heading"><HardHat className="h-5 w-5" />{t("nav.construction")} · {t("cst.site_app")}</div>
    <select className="border rounded h-10 px-2 bg-card text-sm w-full" data-testid="site-project" value={cur} onChange={(e) => setPid(e.target.value)}>{list.map((p) => <option key={p.id} value={p.id}>{p.ref} {p.name}</option>)}</select>
    <InstallHint t={t} />
    <SitePending t={t} />
    <ForecastStrip t={t} pid={cur} />
    <WeatherBoard t={t} pid={cur} compact />
    <CrewCheckin t={t} pid={cur} />
    <DailyLogs t={t} pid={cur} compact />
    <ProjectGallery t={t} pid={cur} compact />
    <FuelReceipt t={t} pid={cur} />
    <Punch t={t} pid={cur} compact />
    <Drawings t={t} pid={cur} />
  </div>;
}
